/**
 * Spacing tokens — mirrored from Figma Variables (collection "base/sizes/spacing").
 *
 * Two exports serve two different roles:
 *
 * `spacing` — the base unit passed to MUI's `theme.spacing(n)` multiplier (n × 8px).
 *   Used by MUI internals and component density calculations. Do not change this without
 *   understanding the blast radius across all MUI components.
 *
 * `spacingTokens` — fixed named steps for use in component `styleOverrides`. These are
 *   absolute px values; they do NOT map into `theme.spacing()` and are not derived from
 *   the base — they are design-system constants matching the Figma scale exactly.
 */
export const spacing = 8;

export const spacingTokens = {
  none: 0,
  sp1: 1,
  sp2: 2,
  sp4: 4,
  sp6: 6,
  sp8: 8,
  sp12: 12,
  sp16: 16,
  sp24: 24,
  sp32: 32,
  sp40: 40,
} as const;

export type SpacingToken = typeof spacing;
export type SpacingTokens = typeof spacingTokens;
